import { Injectable, computed, signal } from '@angular/core';

import { MaintenanceCompanyProfile } from './maintenance-company.service';

/** The signed-in person's maintenance company, loaded once by the company shell and read by its pages. */
@Injectable({ providedIn: 'root' })
export class CompanySessionService {
  readonly company = signal<MaintenanceCompanyProfile | null>(null);
  readonly isAdmin = computed(() => this.company()?.role === 'ADMIN');
  /** True until the signed-in person has given their name (landlords otherwise see their email). */
  readonly needsName = computed(() => !!this.company() && !this.company()?.myName);
}
